<svg xmlns="http://www.w3.org/2000/svg"
     width="64px" height="64px" stroke-linejoin="round"
     viewBox="0 0 64 64">
  <g fill="none" stroke="#000000" stroke-width="4">
  <path class="D8"
        d="M 32.00,2.00
           C 32.00,2.00 58.00,17.00 58.00,17.00
             58.00,17.00 58.00,47.00 58.00,47.00
             58.00,47.00 32.18,62.00 32.00,62.00
             31.82,62.00 6.00,47.00 6.00,47.00
             6.00,47.00 6.00,17.00 6.00,17.00
             6.00,17.00 32.00,2.00 32.00,2.00 Z
           M 58.00,47.00
           C 58.00,47.00 6.00,47.00 6.00,47.00
             6.00,47.00 32.00,2.00 32.00,2.00
             32.00,2.00 58.00,47.00 58.00,47.00 Z" />
   </g>
</svg>
